import axios from "axios";

export default axios.create({
	baseURL: process.env.REACT_APP_API,
	headers: {
		CorrelationId: "*",
		SourceSystem: "obnova-zapomenuteho-hesla-front-end",
		"Access-Control-Allow-Origin": "*",
		Accept: "application/json",
		"Cache-Control": "no-cache",
		Pragma: "no-cache",
		"Content-type": "application/json; charset=UTF-8",
	},
});
